import { useEffect, useInsertionEffect, useState } from 'react'
import { useTheme } from '@/features'
import { ReactComponent as DarkIcon } from '@/shared/images/svg/header-theme-switch-dark.svg'
import { ReactComponent as LightIcon } from '@/shared/images/svg/header-theme-switch-light.svg'
import { tenantConfig } from '@/shared/config/tenant'

export function useChangingTheme() {
    const { currentTheme, switchTheme } = useTheme()

    const [isDark, setIsDark] = useState(currentTheme === 'dark')

    useEffect(() => {
        switchTheme(isDark ? 'dark' : 'light')
        if (isDark) {
            document.body.classList.add('dark')
        } else {
            document.body.classList.remove('dark')
        }
    }, [isDark])

    useInsertionEffect(() => {
        if (isDark) {
            document.documentElement.style.setProperty('--clr-primary', tenantConfig?.color?.dark?.primary || '#40c067')
        } else {
            document.documentElement.style.setProperty('--clr-primary', tenantConfig?.color?.light?.primary || '#40c067')
        }
    }, [isDark])

    return {
        currentTheme,
        isDark,
        setIsDark,
    }
}

export function DarkModeToggle() {
    const { isDark, setIsDark } = useChangingTheme()
    return (
        <button onClick={() => setIsDark(!isDark)} style={{ color: 'var(--clr-primary)'}}>
            {!isDark ? <DarkIcon /> : <LightIcon />}
        </button>
    )
}
